import { useState } from 'react';
import { Reveal } from '@/components/Reveal';
import { SEO, createBreadcrumbSchema } from '@/components/SEO';
import { useSettings } from '@/lib/useSettings';
import { Shield, Cookie, FileDown } from 'lucide-react';
import { API } from '@/lib/data';

export default function KVKKPage() {
  const settings = useSettings();
  const kvkkText = settings.kvkk?.text;
  const cookieText = settings.kvkk?.cookie_text;

  return (
    <div data-testid="kvkk-page">
      <SEO title="KVKK & Çerez Politikası" description="Prof. Dr. Nilüfer Yıldırım - Kişisel verilerin korunması kanunu (KVKK) ve çerez kullanım politikası hakkında bilgilendirme." schema={createBreadcrumbSchema([{ name: 'Ana Sayfa', url: '/' }, { name: 'KVKK & Çerez Politikası' }])} />
      <section className="bg-[#F5F3EF] py-16 sm:py-20">
        <div className="mx-auto max-w-6xl px-4 sm:px-6 lg:px-10">
          <h1 className="font-heading text-[34px] sm:text-[34px] lg:text-[46px] font-semibold tracking-[-0.02em] mb-4">KVKK & Çerez Politikası</h1>
          <p className="text-[22px] text-[#5F6B76] max-w-xl">Kişisel verilerin korunması ve çerez kullanımı hakkında bilgilendirme.</p>
        </div>
      </section>

      <section className="mx-auto max-w-3xl px-4 sm:px-6 lg:px-10 py-12">
        {/* KVKK */}
        <Reveal>
          <div className="mb-12">
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-[#1F6E7A]/10 flex items-center justify-center">
                <Shield size={20} className="text-[#1F6E7A]" />
              </div>
              <h2 className="font-heading text-[30px] font-semibold">KVKK Aydınlatma Metni</h2>
            </div>
            <div className="bg-white rounded-[24px] border border-[#E7E5E4] p-6 sm:p-8 text-[14px] text-[#5F6B76] leading-relaxed whitespace-pre-line">
              {kvkkText || 'KVKK aydınlatma metni henüz admin panelden girilmemiştir.'}
            </div>
            <div className="mt-6">
              <a
                href={`${API}/kvkk-document/download`}
                download
                className="inline-flex items-center gap-2.5 px-6 py-3 rounded-full bg-[#1F6E7A] text-white text-sm font-medium hover:bg-[#185960] transition-colors shadow-sm"
                data-testid="kvkk-basvuru-formu-download-button"
              >
                <FileDown size={18} />
                KVKK Başvuru Formu
              </a>
            </div>
          </div>
        </Reveal>

        {/* Cookie Policy */}
        <Reveal>
          <div>
            <div className="flex items-center gap-3 mb-6">
              <div className="w-10 h-10 rounded-xl bg-[#D8C7A6]/15 flex items-center justify-center">
                <Cookie size={20} className="text-[#D8C7A6]" />
              </div>
              <h2 className="font-heading text-[30px] font-semibold">Çerez Politikası</h2>
            </div>
            <div className="bg-white rounded-[24px] border border-[#E7E5E4] p-6 sm:p-8 space-y-4 text-[14px] text-[#5F6B76] leading-relaxed">
              <p className="whitespace-pre-line">
                {cookieText || 'Çerez politikası metni henüz admin panelden girilmemiştir.'}
              </p>
              <button
                onClick={() => {
                  localStorage.removeItem('cookie_preferences');
                  window.location.reload();
                }}
                className="inline-flex items-center px-5 py-2.5 rounded-full bg-[#1F6E7A] text-white text-sm font-medium hover:bg-[#185960] transition-colors"
                data-testid="cookie-preferences-reset-button"
              >
                Çerez Tercihlerini Yönet
              </button>
            </div>
          </div>
        </Reveal>
      </section>
    </div>
  );
}
